export default __webpack_public_path__ + "static/media/maket-3.ae98fef6.png";